'use strict';
var Module = angular.module('datePicker', []);

Module.constant('datePickerConfig', {
    //template: 'directive/datePicker/datePicker.html',
    view: 'month',
    views: ['year', 'month', 'date', 'hours', 'minutes'],
    momentNames: {
        year: 'year',
        month: 'month',
        date: 'day',
        hours: 'hours',
        minutes: 'minutes',
    },
    viewConfig: {
        year: ['years', 'isSameYear'],
        month: ['months', 'isSameMonth'],
        hours: ['hours', 'isSameHour'],
        minutes: ['minutes', 'isSameMinutes'],
    },
    step: 5
});
//Moment format filter.
Module.filter('mFormat', function() {
    return function(m, format, tz) {
        var result = '';
        if (!(moment.isMoment(m))) {
            result = moment(m).format(format);
        } else {
            result = tz ? moment.tz(m, tz).format(format) : m.format(format);
        }
        return result;
    };
});

Module.directive('datePicker', ['datePickerConfig', 'datePickerUtils', '$timeout', '$rootScope', function datePickerDirective(datePickerConfig, datePickerUtils, $timeout, $rootScope) {
    //noinspection JSUnusedLocalSymbols
    return {
        // this is a bug ?
        require: '?ngModel',
        templateUrl: 'directive/datePicker/datePicker.html',
        scope: {
            model: '=datePicker',
            after: '=?',
            before: '=?',
            choiceDate: '=?',
            trigger: '=?'
        },
        link: function(scope, element, attrs, ngModel) {
            scope.translateWeek = translateWeek;
            var methodList = {
                //有空維護這支程式請方法(無論公有或私有)移到此區塊
                setDate: setDate,
            };
            var arrowClick = false,
                tz = scope.tz = attrs.timezone,
                createMoment = datePickerUtils.createMoment,
                eventIsForPicker = datePickerUtils.eventIsForPicker,
                step = parseInt(attrs.step || datePickerConfig.step, 10),
                partial = !!attrs.partial,
                minDate = getDate('minDate'),
                maxDate = getDate('maxDate'),
                pickerID = element[0].id,
                now = scope.now = createMoment(),
                selected = scope.date = createMoment(scope.model || now),
                autoclose = attrs.autoClose === 'true',
                // Either gets the 1st day from the attributes, or asks moment.js to give it to us as it is localized.
                firstDay = attrs.firstDay && attrs.firstDay >= 0 && attrs.firstDay <= 6 ? parseInt(attrs.firstDay, 10) : moment().weekday(0).day(),

                prepareViewData,
                isSame,
                clipDate,
                isNow,
                inValidRange;

            //==Main==
            init();
            //========
            function init() {
                //有空維護請將屬於初始設定放於此區塊
                datePickerUtils.setParams(tz, firstDay);
            }



            function prepareViews() {
                scope.views = datePickerConfig.views.concat();
                scope.view = attrs.view || datePickerConfig.view;
                scope.views = scope.views.slice(
                    scope.views.indexOf(attrs.maxView || 'year'),
                    scope.views.indexOf(attrs.minView || 'minutes') + 1
                );
                if (scope.views.length === 1 || scope.views.indexOf(scope.view) === -1) {
                    scope.view = scope.views[0];
                }
            }

            function getDate(name) {
                return datePickerUtils.getDate(scope, attrs, name);
            }
            if (!scope.model) {
                selected.minute(Math.ceil(selected.minute() / step) * step).second(0);
            }

            scope.template = attrs.template || datePickerConfig.template;

            scope.watchDirectChanges = attrs.watchDirectChanges !== undefined;
            scope.callbackOnSetDate = attrs.dateChange ? datePickerUtils.findFunction(scope, attrs.dateChange) : undefined;

            prepareViews();

            scope.setView = function(nextView) {
                if (scope.views.indexOf(nextView) !== -1) {
                    scope.view = nextView;
                }
            };
            //todo anson修改為了要關閉日期的地方
            scope.selectDate = function(date) {
                if (attrs.disabled) {
                    return false;
                }
                if (isSame(scope.date, date)) {
                    date = scope.date;
                }
                date = clipDate(date);
                if (!date) {
                    return false;
                }
                scope.date = date;

                
                var nextView = scope.views[scope.views.indexOf(scope.view) + 1];
                if ((!nextView || partial) || scope.model) {
                    setDate(date);
                }

                if (nextView) {
                    scope.setView(nextView);
                } else if (autoclose) {
                    element.addClass('hidden');
                    scope.$emit('hidePicker');
                } else {
                    prepareViewData();
                }
                // anson:為了不關閉，所以判斷autoClose
                if (attrs.minView === scope.views[0] && attrs.autoClose !== 'false') {
                    element.addClass('hidden');
                    scope.$emit('hidePicker');
                }

            };



            function setDate(date, notEmit) {
                //資料實際設定移到 setDate 後續監聽事件處理
                if (date) {
                    scope.model = date;
                    // if (ngModel) {
                    //  ngModel.$setViewValue(date);
                    // }
                }
                if (!notEmit) {
                    scope.$emit('setDate', date, scope.view);
                }

                //This is duplicated in the new functionality.
                if (scope.callbackOnSetDate) {
                    scope.callbackOnSetDate(attrs.datePicker, scope.date);
                }
            };

            function update() {
                var view = scope.view;
                datePickerUtils.setParams(tz, firstDay);

                if (scope.model && !arrowClick) {
                    scope.date = createMoment(scope.model);
                    arrowClick = false;
                }

                var date = scope.date;
                switch (view) {
                    case 'year':
                        scope.years = datePickerUtils.getVisibleYears(date);
                        break;
                    case 'month':
                        scope.months = datePickerUtils.getVisibleMonths(date);
                        break;
                    case 'date':
                        scope.weekdays = scope.weekdays || datePickerUtils.getDaysOfWeek();
                        // scope.weekdays = scope.weekdays || datePickerUtils.getWeekDays();
                        scope.weeks = datePickerUtils.getVisibleWeeks(date);
                        break;
                    case 'hours':
                        scope.hours = datePickerUtils.getVisibleHours(date);
                        break;
                    case 'minutes':
                        scope.minutes = datePickerUtils.getVisibleMinutes(date, step);
                        break;
                }
                if (scope.choiceDate) {
                    initChoiceDate();
                }
            }

            // 透過外部變更 trigger 值來觸發更新行事曆資料
            scope.$watch('trigger', function(data) {
                if (data > 1) {
                    initChoiceDate();
                }
            });

            function translateWeek(weekday) {
                weekday = weekday + '';
                var weekdayName = {
                    '0': $rootScope.translate.tsunWeekSunday || 'Sunday',
                    '1': $rootScope.translate.tsunWeekMonday || 'Monday',
                    '2': $rootScope.translate.tsunWeekTuesday || 'Tuesday',
                    '3': $rootScope.translate.tsunWeekWednesday || 'Wednesday',
                    '4': $rootScope.translate.tsunWeekThusday || 'Thusday',
                    '5': $rootScope.translate.tsunWeekFriday || 'Friday',
                    '6': $rootScope.translate.tsunWeekSaturday || 'Saturday',
                };
                return weekdayName[weekday] || 'unknownday';
            }

            function initChoiceDate() {
                var classes = [],
                    classList = '',
                    i, j, week,
                    weeks = scope.weeks;
                var choiceDateArr = [];

                scope.choiceDate.then(function(data) {

                    // 目前選擇的日期
                    // console.log('scope.date:', scope.date.toDate());

                    // 所有行事曆資料
                    // console.log('data.data.schedules:', jQuery.extend(true, {}, data.data.schedules));

                    var prev2Month = moment(scope.date).subtract(2, 'M');
                    var next1Month = moment(scope.date).add(1, 'M');
                    var next2Month = moment(scope.date).add(2, 'M');
                    var limitDate = moment.range(prev2Month, next2Month);

                    _.each(data.data.schedules, function(x) {

                        // 針對沒有 end 的事件，給予固定值填滿整個當月行事曆
                        if (moment(x.end).isAfter(next1Month)) {
                           x.end = next1Month.format('YYYY-MM-DDTHH:mm:ss');
                        }

                        // 過濾在被選擇日期的上下2月份的所有行事曆資料
                        if (limitDate.contains(moment(x.end))) {
                            choiceDateArr.push(x);
                        }
                    });

                    // 被選擇日期的上下2月份的所有行事曆資料
                    // console.log('choiceDateArr:', jQuery.extend(true, {}, choiceDateArr));

                    var dateRange = _.chain(choiceDateArr)
                        .forEach(function(x) {
                            var end = moment(x.end);
                            // 沒有加這行在下個階段會產生區間日期計算錯誤
                            x.end = end.hour() < 9 ? end.subtract(1, 'day').format('YYYY-MM-DDTHH:mm:ss') : end.format('YYYY-MM-DDTHH:mm:ss');
                        })
                        .map(function(x) {
                            // 計算區間中的每個日期
                            var result = moment.range(moment(x.start).toDate(), moment(x.end).toDate()).toArray('days');
                            return result;
                        })
                        .flatten()
                        .map(function(x) {
                            return x.format('YYYYMMDD');
                        })
                        .uniq()
                        .sortBy()
                        .value();

                    // 需要顯示圈圈的日期
                    // console.log('dateRange:', dateRange);

                    for (i = 0; i < weeks.length; i++) {
                        week = weeks[i];
                        classes.push([]);
                        for (j = 0; j < week.length; j++) {
                            classList = '';
                            _.each(dateRange, function(x) {
                                if (x === moment(week[j]).format('YYYYMMDD')) {
                                    classList += 'choice';
                                }
                            });

                            classes[i].push(classList);
                        }
                    }
                    scope.classes = classes;
                });
            }

            function watch() {
                var result;
                if (scope.view !== 'date') {
                    result = scope.view;
                } else {
                    result = scope.date ? scope.date.month() : null;
                }
                return result;
            }

            scope.$watch(watch, function() {
                update();
            });

            if (scope.watchDirectChanges) {
                scope.$watch('model', function() {
                    arrowClick = false;
                    update();
                });
            }

            prepareViewData = function() {
                var view = scope.view,
                    date = scope.date,
                    classes = [],
                    classList = '',
                    i, j, choiceDay;

                datePickerUtils.setParams(tz, firstDay);
                if (view === 'date') {
                    var weeks = scope.weeks,
                        week;


                    for (i = 0; i < weeks.length; i++) {
                        week = weeks[i];
                        classes.push([]);
                        for (j = 0; j < week.length; j++) {
                            classList = '';
                            // if (datePickerUtils.isSameDay(date, week[j])) {
                            //     classList += 'active';
                            // }
                            // if (isNow(week[j], view)) {
                            //     classList += ' now';
                            // }
                            //if (week[j].month() !== date.month()) classList += ' disabled';
                            // if (week[j].month() !== date.month() || !inValidRange(week[j])) {
                            //     classList += ' disabled';
                            // }



                            classes[i].push(classList);
                        }
                    }

                } else {
                    var params = datePickerConfig.viewConfig[view],
                        dates = scope[params[0]],
                        compareFunc = params[1];

                    for (i = 0; i < dates.length; i++) {
                        classList = '';
                        if (datePickerUtils[compareFunc](date, dates[i])) {
                            classList += 'active';
                        }
                        if (isNow(dates[i], view)) {
                            classList += ' now';
                        }
                        if (!inValidRange(dates[i])) {
                            classList += ' disabled';
                        }
                        classes.push(classList);
                    }
                }
                // scope.classes = classes;
            };

            scope.next = function(delta) {
                var date = moment(scope.date);
                delta = delta || 1;
                switch (scope.view) {
                    case 'year':
                        /*falls through*/
                    case 'month':
                        date.year(date.year() + delta);
                        break;
                    case 'date':
                        date.month(date.month() + delta);
                        break;
                    case 'hours':
                        /*falls through*/
                    case 'minutes':
                        date.hours(date.hours() + delta);
                        break;
                }
                date = clipDate(date);

                if (date) {
                    scope.date = date;
                    setDate(date, true);
                    arrowClick = true;
                }
            };

            inValidRange = function(date) {
                var valid = true;
                if (minDate && minDate.isAfter(date)) {
                    valid = isSame(minDate, date);
                }
                if (maxDate && maxDate.isBefore(date)) {
                    valid &= isSame(maxDate, date);
                }
                return valid;
            };

            isSame = function(date1, date2) {
                return date1.isSame(date2, datePickerConfig.momentNames[scope.view]) ? true : false;
            };

            clipDate = function(date) {
                if (minDate && minDate.isAfter(date)) {
                    return minDate;
                } else if (maxDate && maxDate.isBefore(date)) {
                    return maxDate;
                } else {
                    return date;
                }
            };

            isNow = function(date, view) {
                var is = true;

                switch (view) {
                    case 'minutes':
                        is &= ~~(now.minutes() / step) === ~~(date.minutes() / step);
                        /* falls through */
                    case 'hours':
                        is &= now.hours() === date.hours();
                        /* falls through */
                    case 'date':
                        is &= now.date() === date.date();
                        /* falls through */
                    case 'month':
                        is &= now.month() === date.month();
                        /* falls through */
                    case 'year':
                        is &= now.year() === date.year();
                }
                return is;
            };

            scope.prev = function(delta) {
                return scope.next(-delta || -1);
            };

            if (pickerID) {
                scope.$on('pickerUpdate', function(event, pickerIDs, data) {
                    if (eventIsForPicker(pickerIDs, pickerID)) {
                        var updateViews = false,
                            updateViewData = false;

                        if (angular.isDefined(data.minDate)) {
                            minDate = data.minDate ? data.minDate : false;
                            updateViewData = true;
                        }
                        if (angular.isDefined(data.maxDate)) {
                            maxDate = data.maxDate ? data.maxDate : false;
                            updateViewData = true;
                        }

                        if (angular.isDefined(data.minView)) {
                            attrs.minView = data.minView;
                            updateViews = true;
                        }
                        if (angular.isDefined(data.maxView)) {
                            attrs.maxView = data.maxView;
                            updateViews = true;
                        }
                        attrs.view = data.view || attrs.view;

                        if (updateViews) {
                            prepareViews();
                        }

                        if (updateViewData) {
                            update();
                        }
                    }
                });
            }
        }
    };
}]);
